@use '@/scss/underscore' as _;

.number {
  font: var(--font-headline-3);
}

.delta {
  font: var(--font-title-2);
  color: var(--color-success-50);
  display: flex;
  align-items: center;

  &.down {
    color: var(--color-error-50);
  }
}

.block {
  flex: 1;

  &:not(:last-child) {
    margin-right: _.unit(4);
  }

  &.bordered {
    border: 1px solid var(--color-divider);
    width: 360px;
    flex: unset;
  }

  .title {
    font: var(--font-title-2);
    margin-bottom: 24px;
    display: flex;
    align-items: center;

    .toggleTipButton {
      margin-left: _.unit(0.5);
    }
  }

  .content {
    display: flex;
    align-items: baseline;

    .number {
      flex: 1;
    }
  }

  &.plain {
    padding: 0;

    .title {
      font: var(--font-title-2);
      margin-bottom: _.unit(6);
    }

    .content {
      display: flex;
      align-items: center;

      .number {
        margin-right: _.unit(2);
        flex: 0;
      }
    }
  }
}
